var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var InfoFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM34.7826 25.9414H29.2174V49.1895H34.7826V25.9414ZM29.2174 14.8105H34.7826V20.3758H29.2174V14.8105Z"
  }));
};
export var InfoFilledIconGlyph = function (props) {
  return React.createElement(InfoFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};